<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">TSP Rate Procurement Report</legend>
  </div>
  <form id="carrierRateProcSearchGroup" role="form" [formGroup]="carrierRateProcSearchGroup">
    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="type" class="usa-label">Type</label>
        <select id="type" class="usa-select" formControlName='typeSelect'
          (change)="onSelectType($event.target.value)">
          <option value ='null' selected disabled>Choose one...</option>
          @for (typeSingle of searchTypes; track typeSingle) {
            <option>{{typeSingle}}</option>
          }
        </select>
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="scacSelect" class="usa-label">SCAC</label>
        <select id="scacSelect" class="usa-select" formControlName='scacSelect'>
          @for (scacSingle of scacItems; track scacSingle) {
            <option [value]="scacSingle.value">{{scacSingle.name}}</option>
          }
        </select>
      </div>
    </div>
    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="rateTypeSelect" class="usa-label">Rate Type</label>
        <select id="rateTypeSelect" class="usa-select" formControlName='rateTypeSelect' (change)="rateTypeChange($event.target.value)">
          @for (rateTypeSingle of rateTypeItems; track rateTypeSingle) {
            <option
            [value]="rateTypeSingle.value">{{(rateTypeSingle.value === 'All') ? '': (rateTypeSingle.value + ' - ')}}  {{rateTypeSingle.name}}</option>
          }
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="sroSelect" class="usa-label">SRO</label>
        <select id="sroSelect" class="usa-select" formControlName='sroSelect'>
          @for (sroSingle of sroItems; track sroSingle) {
            <option [value]="sroSingle.value">{{sroSingle.name}}</option>
          }
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="rateCycleSelect" class="usa-label">Rate Cycle</label>
        <select id="rateCycleSelect" class="usa-select" formControlName='rateCycleSelect' (change)="onSelectRateCycle()">
          <option value ='null' selected disabled>Choose one...</option>
          @for (rateCycleSingle of rateCycleItems; track rateCycleSingle) {
            <option [value]="rateCycleSingle.ratesBidcyclesId">
              {{rateCycleSingle.bidCycleName}} ( {{rateCycleSingle.rateEffectiveDate | date}}
              - {{rateCycleSingle.rateExpiryDate | date}} )
            </option>
          }
        </select>
      </div>
    </div>
    <div class="grid-row margin-top-2">
      <button type="button" [disabled]='!this.carrierRateProcSearchGroup.valid' class="usa-button"
        (click)='generateReport(this.carrierRateProcSearchGroup.value)'>Generate
      </button>
    </div>
  </form>
  @if (noResults!==null) {
    <div class="margin-top-2">
      {{noResults}}
    </div>
  }
  @if (noResults===null && carrierTypeProcListDetails && carrierTypeProcListDetails.length>0) {
    <div class="padding-top-4">
      <div>
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
        </svg>
        Right click on the report and select the appropriate options to export.
      </div>
      <div>
        <ag-grid-angular
          class="ag-theme-alpine"
          style="width: 100%;"
          [gridOptions]="carrierRateProcurementGridOptions"
          [rowData]="carrierTypeProcListDetails"
          [columnDefs]="carrerColumnDefs"
          [suppressDragLeaveHidesColumns]="true"
          ag-grid-resize>
        </ag-grid-angular>
      </div>
    </div>
  }
</div>
